<template>
	<vue-scroll>
		<div class="page-contacts flex column scrollable only-y mb-20" id="page-contacts"
			v-show="userPermissionsFilter.preapprovetransactions" v-loading="pageLoading"
			:element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
			<div>
				<h2 class="text-white">Transactions Pending Approval</h2>
				<div id="plug">
					<div v-if="showTimer" class="v" style="color:red">We are moving this module to <a
							:href=newbackofficeurl target="_blank">New
							Backoffice</a>. This module will be permanently disabled in {{ timerOutput }}</div>
					<div v-else class="v"></div>
				</div>
				<div class="table-responsive">
					<table class="table" id="datatable" style="color:white;">
						<thead>
							<tr>
								<th>Ref</th>
								<th>Made By</th>
								<th>Date</th>
								<th>Sender Name</th>
								<th>Amount</th>
								<th>Type</th>
								<th>Rate</th>
								<th>Tarrif</th>
								<th>Receiver Name</th>
								<th>Receiver Amount</th>
								<th v-show="userPermissionsFilter.preapprovetransactions">Action</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in usersdata" :key="item.id">
								<td>{{ item.referenceNumber }}</td>
								<td><span v-if="item.selfService = 'false'">BO Agent</span><span v-else>Customer</span>
								</td>
								<td>{{ formatShortDate(item.createdOn) }}</td>
								<td>{{ item.senderName }}</td>
								<td>{{ item.senderCurrencySymbol }} {{ item.senderAmount }}</td>
								<td>{{ item.serviceName }}</td>
								<td>{{ item.exchangeRate }}</td>
								<td>{{ item.senderCurrencySymbol }} {{ item.tariffFee }}</td>
								<td>{{ item.receiverFirstName }} {{ item.receiverMiddleName }} {{ item.receiverLastName
									}}
								</td>
								<td>{{ item.receiverCurrencySymbol }} {{ item.receiverAmount }}</td>
								<td v-show="userPermissionsFilter.preapprovetransactions"><el-button
										@click="transactionAuthorization(item)"><i
											class="mdi mdi-check-circle"></i></el-button></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</vue-scroll>
</template>

<script>
import { newbackofficeurl } from "../../package.json";
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'approveBackofficeTransaction',
	data: function () {
		return {
			usersdata: '',
			userdata: '',
			//IdProfile = "data:image/png;base64," + response.data;
			newbackofficeurl: "",
			countDownToTime: new Date('Oct 15, 2024 00:00:00').getTime(),
			timerOutput: '',
			showTimer: true
		}
	},
	computed: {
	},
	methods: {
		transactionAuthorization(row) {
			router.push("/transactionauthorization/" + row.id);
		},
		refreshUsers() {
			this.startLoader("Getting Transactions...");
			this.getPreapproveTransactions(1, 200)
				.then((result) => {
					//console.log(result.items);
					this.usersdata = result.items;
					this.$nextTick(function () {
						this.initDt()
					});
					this.stopLoader();
				}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
		},
		initDt() {
			var cmp = this.userdata.fullName + " Transactions";
			var cmp_logo = this.loggedInCompany.logo;
			$('#datatable').DataTable({
				retrieve: true,
				dom: 'Blfrtip',
				"aaSorting": [],
				buttons: [
					// {
					// 	extend : 'pdfHtml5',
					// 	title : function() {
					// 		return cmp;
					// 	},
					// 	orientation : 'landscape',
					// 	pageSize : 'A3', // You can also use "A1","A2" or "A3", most of the time "A3" works the best.
					// 	text : '<i class="fa fa-file-pdf-o"> PDF</i>',
					// 	titleAttr : 'PDF',
					// 	messageBottom: 'This report was generated By '+this.loggedInUser,

					// },
					{
						extend: 'print',
						orientation: 'landscape',
						pageSize: 'A3', // You can also use "A1","A2" or "A3", most of the time "A3" works the best.
						customize: function (doc) {
							doc.content.splice(1, 0, {
								margin: [0, 0, 0, 10],
								alignment: 'center',
								image: cmp_logo
							});
						}
					},
					// {
					// 	extend: 'csv',
					// 	//messageTop: cmp,
					// 	title : function() {
					// 		return cmp;
					// 	},
					// 	messageBottom: 'This report was generated By '+this.loggedInUser,
					// },
					// {
					// 	extend: 'excel',
					// 	title : function() {
					// 		return cmp;
					// 	},
					// 	messageBottom: 'This report was generated By '+this.loggedInUser,
					// },
				],

			});
		}
	},
	mounted() {
		//API Call
	},
	created() {
		this.startTimer();
		let self = this;
		this.newbackofficeurl = self.$newbackofficeurl;
		this.refreshUsers();
	},
	mixins: [PermissionsMixins]
}

</script>

<style>
.avatar-box {
	background: #3773e2;
	margin-bottom: 50px;
	position: relative;
}

.avatar-box img {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	position: relative;
	bottom: -50px;
	display: block;
	margin: 0 auto;
	background: white;
	border: 2px solid #3773e2;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
</style>